<template>
    <div class="rightPanel" v-show="visible">

        <el-card class="box-card">
            <el-divider></el-divider>
            <div class="score-list" :style="scoreListHeight">
                <el-row class="head" >
                    <el-col :span="12">
                        <span>学生总分:</span>
                    </el-col>
                    <el-col :span="12">
                        <span>{{studentTotalScore}}</span>
                    </el-col>
                </el-row>
                <el-row class="head" >
                    <el-col :span="12">
                        <span>批阅教师:</span>
                    </el-col>
                    <el-col :span="12">
                        <span>{{zgInfo.teacherName}}</span>
                    </el-col>
                </el-row>
                <el-row class="head" >
                    <el-col :span="4">
                        <span>块得分:</span>
                    </el-col>
                    <el-col :span="8">
                        <!-- <span>{{zgInfo.scoreByZg}}</span> -->
                        <span>{{seqTotalScore}}</span>
                    </el-col>
                </el-row>
                <!-- <el-row class="head" >
                  <el-col :span="4">
                    <span>平均分:</span>
                  </el-col>
                  <el-col :span="8">
                    <span>{{serAverage}}</span>
                  </el-col>
                  <el-col :span="12" >
                    <span>(您阅卷该题的平均分)</span>
                  </el-col>
                </el-row> -->

                <el-row class="head">
                    <el-col :span="4">
                        <span>题号</span>
                    </el-col>
                    <el-col :span="8">
                        <span>得分</span>
                    </el-col>
                    <el-col :span="3">
                        <span>满分</span>
                    </el-col>
                    <el-col :span="8" v-if="topicData && topicData.length > 1 && topicMode==1">
                        <el-checkbox v-model="autoNext">自动跳题</el-checkbox>
                    </el-col>
                  <!-- <el-col :span="8" v-if="(!topicData || topicData.length == 1) && topicMode==1"> -->
<!--                    <el-checkbox v-model="autoSubmit" style="color: red;">自动提交分数</el-checkbox>-->
<!--                    <el-checkbox v-model="nocheckzero">0分无需确认</el-checkbox>-->
                      <!-- <div class="checkbox-wrapper">
                        <el-checkbox v-model="autoSubmit" style="color: red;">自动提交分数</el-checkbox>
                      </div>
                      <div class="checkbox-wrapper">
                        <el-checkbox v-model="nocheckzero">0分无需确认</el-checkbox>
                      </div>
                  </el-col> -->

                </el-row>
                <el-row v-for="(item, index) in topicData" class="score-row">
                    <el-col :span="4">
                        <span class="text" v-if="selTopic!=null && selTopic.topicIndex==item.topicIndex" style="color: red;">*</span>
                        <span class="text" :style="(selTopic!=null && selTopic.topicIndex==item.topicIndex)?{color: 'red'}: {}">{{item.topicNo}}</span>
                    </el-col>
                    <el-col :span="8">
                        <!-- <el-input v-model="item.score" placeholder="分数" @focus="scoreFocus(item)" @keydown.native="scoreKeyDown" style="width: 80px;" ></el-input> -->
                        <span class="text">{{item.score}}</span>
                    </el-col>
                    <el-col :span="3">
                        <span class="text">{{item.rightScore}}</span>
                    </el-col>

                </el-row>

                <el-row style="text-align: left; margin-top: 20px;font-weight: bold;">
                    <el-divider></el-divider>
                    <span>存疑意见：</span>
                </el-row>

                <el-row>
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请填写存疑意见"
                        v-model="remark">
                    </el-input>
                </el-row>
                   

            </div>
            <el-row style="margin-top: 25px;">
                <el-col :span="12">
                    <el-button type="primary" :loading="loading" @click='submitForm("YY")'>复核通过</el-button>
                </el-col>
                <el-col :span="12">
                    <el-button type="danger"  :loading="loading"  @click='submitForm("YC")'>存疑</el-button>
                </el-col>
            </el-row>

        </el-card>
    </div>

</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'

    export default {
        name: 'rightPanel',
        data(){
            return {
                formLabelWidth: '120px', 
                myTitle: null, 
                scoreListHeight:{}, 
                isQuickScore: false,//是否快捷打分，填空题
                loading: false, 
                topicData: [], 
                zgIds: [],  
                caidianStepList: [], 
                status: null,
                topicMode: 1, 
                topicType: null, 
                topicValue: null, 
                caidianMode: 0, 
                caidianStep: 1, 
                autoNext: false, 
                autoSubmit: false,
                nocheckzero:false,
                fullScore: 0, 
                scoreList: [], 
                selTopic: null, 
                bySteps: [], 
                selStep: null,
                examId: null, 
                examSeq: null, 
                markRecords: null,
                seqAverageScore:null,
                examScoreType:null,
                studentTotalScore: 0,
                recheckForm: {},
                // 存疑意见
                remark: null
            }
        },
        components:{
        },
        created() {
            this.caidianStepList.push(0.25);
            this.caidianStepList.push(0.5);
            this.caidianStepList.push(1);
            this.caidianStepList.push(2);
            this.caidianStepList.push(3);
            this.caidianStepList.push(4);
            this.caidianStepList.push(5);
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
            seqTotalScore(){
                if(this.topicData && this.topicData.length >= 1){
                    let score = 0;
                    for (let i=0; i<this.topicData.length; i++) score = score+ XEUtils.toNumber(this.topicData[i].score);
                    return score;
                }
                return 0;
            },
          serAverage(){
              return this.seqAverageScore;
          }
        },
      	mounted() {
            let myHeight = document.documentElement.clientHeight ;
            this.scoreListHeight = {maxHeight: (myHeight*0.6)+'px'};
            this.remark = ''
	    },
        props: {
            zgInfo: {
                type: Object
            },
            visible: {
                type: Boolean
            },
            showAllExam: {
                type: Boolean
            },
            isEdit: {
              type: Boolean, default: false
            },
        },
        watch: {
            zgInfo: {
                deep: true, immediate:true,
                handler(n, o){
                    console.log("zgInfo", n)
                    let that = this;
                    if(n){
                        this.examId = n.examId;
                        this.seqAverageScore = n.seqAverageScore;
                        if(n.examScoreType){
                          this.examScoreType = n.examScoreType;
                          this.topicMode =   parseInt(this.examScoreType, 10);
                        }

                        if(this.examSeq != n.examSeq) {
                            this.autoNext = false;
                            this.autoSubmit = false;
                        }
                        if(n.isQuickScore) this.isQuickScore = n.isQuickScore
                        this.status = n.status;
                        this.examSeq = n.examSeq;
                        this.zgIds = n.zgIds;
                        this.markRecords = null;
                        if(n.markRecords != null && n.markRecords[0] != null){
                            console.log('markRecords', n.markRecords);
                            this.markRecords = JSON.parse(n.markRecords[0]);
                        }
                        this.getStudentScore()
                        this.loadTopicList(function () {
                            that.fillScoreInfo(function (){
                              if(that.topicType=='FillBlank' && that.topicMode==2){
                                // that.$emit('quickScore', {show: true, topicType: that.topicType, topicData: that.topicData});
                              }
                              // setTimeout(function (){
                              //   console.log("show topicData", that.topicData)
                              // }, 2000)
                            });
                        });
                    }

                }
            },
            selTopic: {
                deep: true, immediate:true,
                handler(n, o){
                    if(n!=null && n.rightScore>0){
                        this.rightScore = n.rightScore;
                        this.stepChange();
                    }
                }
            },
            topicMode: {
                deep: true, immediate:true,
                handler(n, o){
                    if(n!=2){
                      this.setExamMode(-1, null);
                    }
                    let showQuick = false;
                    if(this.topicType=='FillBlank' && n==2 && this.status != 'YY') showQuick = true
                    this.$emit('quickScore', {show: showQuick, topicType: this.topicType, topicData: this.topicData});
                }
            },

        },
        methods: {
          reEdit(){
            this.dialogVisible = false;
            this.$emit('reEdit');
          },
          quickScoreChange(v){
            this.isQuickScore = v
            // if(v) this.topicMode = 2
            this.$emit('quickScore', {show: v, topicType: this.topicType, topicData: this.topicData});
          },
          quickScoreDefault(){
            console.log("quickScoreDefault....")
            this.$emit('quickScore', {show: true, reset: true, topicType: this.topicType, topicData: this.topicData});
          },
            cancel(){
                this.dialogVisible = false;
                this.$emit('cancel');
            },
          topicModeChange(v){
            // console.log("topicModeChange", v)
            if(v == 2){
              this.selTopic.score = 0
            }
          },
            stepChange(){
                this.scoreList = [];
                let rightScore = this.selTopic.rightScore;
                let stepCount = Math.round(rightScore / this.caidianStep);
                console.log("stepChange", stepCount, rightScore);
                for (let i=stepCount; i>0; i--){
                    this.scoreList.push({topicIndex: this.selTopic.topicIndex, rightScore: this.selTopic.rightScore, value: rightScore});
                    rightScore = rightScore - this.caidianStep;
                    if(rightScore <=0) rightScore = 0;
                }

                this.scoreList.push({topicIndex: this.selTopic.topicIndex, rightScore: this.selTopic.rightScore, value: 0});
            },
            loadTopicList(callback){
                let that = this;
                this.topicData = [];
                let seqs = this.examSeq.split(",");
                let search = { examId: this.examId, topicIndexs: seqs};
                let param = { controllerName: 'akExamTopic', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadTopicList", data)
                    if (data.code == 0) {
                        let list = data.result;
                        for (let i=0; i<list.length; i++){
                            let d = list[i];
                            that.topicType = d.topic_type;
                            let tfind = XEUtils.find(that.topicData, item => item.topicIndex == d.topic_index);
                            if(!tfind){
                                let o = {topicIndex: d.topic_index, topicNo: d.topic_no, topicType: d.topic_type, rightScore: d.score, score: 0, };
                                that.topicData.push(o);
                            }
                        }
                        if(that.status != 'YY' && that.isQuickScore && that.topicType=='FillBlank') that.quickScoreChange(that.isQuickScore)
                        this.selTopic = that.topicData[0];
                        that.scoreFocus(this.selTopic);
                        if(this.caidianMode ==1 ){ //如果踩点打分是减分，默认是满分
                            this.selTopic.score = this.selTopic.rightScore;
                        }
                        if(callback) callback();
                    }
                    that.loading = false;
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            addSteps(){
                this.bySteps.push({name: '维度'+(this.bySteps.length+1), score: 0});
                this.selStep = this.bySteps[this.bySteps.length-1];
            },
            delStep(index){
                this.bySteps.splice(index, 1);
            },
            setScore1(item, v){
                this.selTopic = item;
                this.selTopic.score = v;
            },
            setScore(item){
                this.selTopic.score = item.value;
                if(this.autoSubmit){
                  this.jumpAutoSubmit();
                  return ;
                }
                this.jumpNext();
            },
            caidianChange(v){
                console.log("caidianChange", v, this.selTopic);
                // if(v == 0 && this.selTopic != null ){
                //     this.selTopic.score = 0;
                // }
                // if(v == 1 && this.selTopic != null ){
                //     this.selTopic.score = this.selTopic.rightScore;
                // }
            },
            fillScoreInfo(callback){
                console.log("fillScoreInfo", this.markRecords, this.topicData);
                if(this.markRecords !=null && "scoreInfo" in this.markRecords){
                    let scoreInfo = this.markRecords["scoreInfo"];
                    let topicData = scoreInfo.topicData;
                    this.topicData.forEach((t, index) => {
                        let tfind = XEUtils.find(topicData, item => {
                            return item.topicIndex == t.topicIndex;
                        })
                        if(tfind){
                          t.score = XEUtils.toNumber(tfind.score);
                          console.log("match score", t.score, tfind)
                        }

                    });
                    let setting = scoreInfo["setting"];
                    if(("topicMode" in setting)) this.topicMode = setting.topicMode; else this.topicMode = 0;
                    if("bySteps" in setting) this.bySteps = setting.bySteps==null?[]:setting.bySteps;
                    if("caidianMode" in setting) {
                      this.caidianMode = scoreInfo.caidianMode;
                    }else this.caidianMode = 0;
                    if("caidianStep" in setting) this.caidianStep = scoreInfo.caidianStep; else this.caidianStep = 1;
                    this.topicValue = null;
                    if(callback) callback()
                }else{
                    // this.topicMode = 0;
                    // this.bySteps = [];
                    // this.caidianMode = 0;
                    // this.caidianStep = 1;
                    // this.topicValue = null;
                }
            },
            jumpAutoSubmit(){
              if(this.autoSubmit){
                this.submitForm();
              }
            },
            jumpNext(){
                if(this.autoNext){
                    if(this.selTopic == null){
                        this.selTopic = this.topicData[0];
                    }else{
                        let fidx = XEUtils.findIndexOf(this.topicData, item => item.topicIndex == this.selTopic.topicIndex);
                        if(fidx > -1){
                            if(fidx < this.topicData.length-1){
                                this.selTopic = this.topicData[fidx+1];
                            }else{
                                this.selTopic = this.topicData[0];
                            }
                        }
                    }
                    this.setExamMode(99, this.topicValue);
                }
            },
            caidianScore(topicIndex, v, isReset, isTopicValue){ //踩点打分，添加分数
                console.log("caidianScore", topicIndex, v, isReset, isTopicValue);
                let fidx = XEUtils.find(this.topicData, item => item.topicIndex == topicIndex);
                if(fidx){
                    if(isTopicValue) this.topicValue = null;
                    if(isReset){
                        fidx.score = 0;
                        // return true;
                    }
                    let s = XEUtils.toNumber(fidx.score);
                    s = s + v;
                    if(s < 0) return false;
                    if(s > fidx.rightScore) return false;
                    fidx.score = s;
                    this.jumpNext();
                }
                return true;
            },
            topicValueChange(v){
                this.setExamMode(99, this.topicValue);
            },
            makeTopicValue(v){
                if(this.topicMode==2){
                    console.log("setTopicValue", v);
                    this.topicValue = v;
                }
            },
            scoreFocus(item){
                this.selTopic = item;
                if(this.topicMode==2){
                    this.setExamMode(99, this.topicValue);
                }
            },
            scoreFocusByIndex(idx){
              this.selTopic = this.topicData[idx];
            },
            setStepFocus(item){
                this.selStep = item;
            },
            setStepScore(item){
                if(this.selStep != null) this.selStep.score = item.value;
                if(this.topicMode == 3 && this.selTopic != null && this.bySteps.length > 0){
                    this.selTopic.score = 0;
                    this.bySteps.forEach((t, index)=>{
                        this.selTopic.score = this.selTopic.score + XEUtils.toNumber(t.score);
                    })
                }
            },
            stepBlur(){
                if(this.topicMode == 3 && this.selTopic != null && this.bySteps.length > 0){
                    this.selTopic.score = 0;
                    this.bySteps.forEach((t, index)=>{
                        this.selTopic.score = this.selTopic.score + XEUtils.toNumber(t.score);
                    })
                }
            },
          clearScoreByStep(){
            this.bySteps.forEach((t, index)=>{
              t.score = 0;
            })
          },
            clearScore(){
              console.log('clear score......')
                this.topicData.forEach((item, index) => {
                    item.score = 0;
                });
              // if(this.topicType=='FillBlank' && this.topicMode==2) this.quickScoreDefault()
            },
            makeScore(v){
              console.log('make score......')
                for (let i=0; i<this.topicData.length; i++){
                    let t = this.topicData[i];
                    if(v ==0) t.score = 0;
                    if(v ==1) t.score = t.rightScore;
                }
            },
            scoreKeyDown(e){
                if(this.topicMode ==1 || this.topicMode ==3){
                    let key = e.key;
                    if(key == '1' || key == '2' || key == '3' || key == '4' || key == '5' || key == '6' || key == '7' || key == '8' || key == '9' || key == '0' || key == '.'){
                        return true;
                    }else if( key == 'Enter'){
                      this.$confirm(`确定提交当前分数吗？`, '提示', {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                      }).then(() => {
                        this.submitForm()
                      }).catch((err) => {
                        console.log("err", err);
                      });
                    }
                }
                e.returnValue = false;
                return false;
            },
            setShowAllExam(){
                this.$emit('okExam');
            },
            setExamMode(mode, myValue){
                let o = null;
                if(this.selTopic != null) o = {topicIndex: this.selTopic.topicIndex, rightScore:this.selTopic.rightScore,  myScore: myValue, step: this.caidianStep};
                this.$emit('changeMode', mode, o);
            },
            validate(){
                if(this.topicMode ==1 || this.topicMode ==2 || this.topicMode ==3){
                    for (let i=0; i<this.topicData.length; i++){
                        let t = this.topicData[i];
                        let myScore = XEUtils.toNumber(t.score);
                        if(myScore < 0){
                            this.$alert('第' + t.topicIndex +'题 分数不能小于0分', '错误');
                            return false;
                        }
                        if(myScore > t.rightScore){
                            this.$alert('第' + t.topicIndex +'题 分数不能超过'+t.rightScore+'分', '错误');
                            return false;
                        }
                    }
                }

                return true;
            },
            toLast(){

                let param = { controllerName: 'examTask', methodName: '/updateUddt', param: {zgIds: this.zgIds, status: '02'}};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    console.log('submitUddt', code);
                    if (code == 0) {
                        this.$message({message: '暂阅成功！', type: 'success', duration: 2000});
                        this.$emit('submitNext');
                    }else{
                        this.$message({message: '暂阅失败！', type: 'error', duration: 2000});
                    }

                });

            },
            submitForm(type){
                this.loading = true;
                this.$emit('submitScore', type,this.remark);
                this.loading = false;
                this.remark = null
                // this.clearScoreByStep()
            },
            getStudentScore(){
                let search = {examId: this.zgInfo.examId ,licenceId:this.userInfo.licenceId,studentId: this.zgInfo.studentId}
                let param = { controllerName: 'examTask', methodName: '/countStudentScore', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    this.studentTotalScore = data
                })

            }
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .checkbox-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .rightPanel{
        // position: absolute;
        // top: 70px;
        // right: 0;
        position: fixed;
        /* 以下属性根据需要调整 */
        top: 0;          /* 固定在顶部 */
        right: 0;         /* 左侧对齐 */
        // z-index: 1000;   /* 确保在其他元素上方 */
        .text {
            font-size: 14px;
        }
        .text-active {
            color: red;
        }
        .item {
            margin-bottom: 18px;
        }
        .box-card {
            width: 380px;
        }
        .score-list {
            overflow-y: auto;
            .head{
                font-weight: bold;
                margin-bottom: 8px;
            }
            .score-row {
                .text{
                    line-height: 30px;
                }
            }
        }
        .board-list {
            margin-top: 15px;
            .score-btn {
                width: 68px;
                margin-top: 8px;
            }
            .radio-btn {
                width: 60px;
                margin-top: 8px;
                margin-right: 8px;

                .el-radio-button__inner {
                    color: black;
                    border: 1px solid #DCDFE6;
                    border-radius: 4px;
                    font-size: 14px;
                }
            }
            .radio-fu {

                .el-radio-button__inner {
                    color: red;
                }
            }
        }
    }


</style>


